export const FILTERS_ALL = "all";
export const FILTERS_UNASIGNED = "unassigned";
export const FILTERS_ACCEPTED = "accepted";
export const FILTERS_IN_PROGRESS = "in-progress";
export const FILTERS_PAUSED = "paused";
export const FILTERS_CANCELED = "canceled";
export const FILTERS_FINISHED = "finished";
export const FILTERS_NOTIFICATION = "notification";
export const FILTERS_PENDING = "pending";

export const PRESET_ACTIVE = "active";
export const PRESET_DONE = "done";
export const PRESET_ALL = "all-preset";
export const PRESET_CUSTOM = "custom";
